class CouponCode extends HTMLElement {
  constructor() {
    super();
    this.copyButton = this.querySelector('.coupon-code__copy-button');
    this.couponCode = this.dataset.couponCodeText;
    this.copyText = this.copyButton.querySelector('.copy');
    this.copiedText = this.copyButton.querySelector('.copied');
  }

  connectedCallback() {
    this.copyButton.addEventListener('click', this.copyToClipboardBound);
  }

  disconnectedCallback() {
    this.copyButton.removeEventListener('click', this.copyToClipboardBound);
  }

  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.couponCode);

      this.copyText.classList.remove('active');
      this.copiedText.classList.add('active');

      setTimeout(() => {
        this.copyText.classList.add('active');
        this.copiedText.classList.remove('active');
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  }

  copyToClipboardBound = this.copyToClipboard.bind(this);
}

if (!customElements.get('coupon-code')) {
  customElements.define('coupon-code', CouponCode);
}
